<template>
  <div v-if="updateAvailable" class="update-banner">
    <div class="update-banner-content">
      <div class="update-banner-text">
        <strong>Update available</strong>
        <span>Version {{ storeVersion }} is ready to install.</span>
      </div>
      <div class="update-banner-actions">
        <button class="update-btn-primary" @click="handleUpdate">Update</button>
        <button
          class="update-btn-dismiss"
          @click="dismiss"
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAppUpdateCheck } from '@/composables/useAppUpdateCheck';

const { updateAvailable, storeVersion, openAppStore, dismiss } =
  useAppUpdateCheck();

async function handleUpdate() {
  await openAppStore();
}
</script>

<style scoped>
.update-banner {
  position: fixed;
  top: env(safe-area-inset-top, 0);
  left: 0;
  right: 0;
  z-index: 9999;
  background: #004751; /* your brand deep teal */
  color: white;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.update-banner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: 800px;
  margin: 0 auto;
}

.update-banner-text {
  display: flex;
  flex-direction: column;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
}

.update-banner-text strong {
  font-weight: 600;
}

.update-banner-text span {
  opacity: 0.85;
  font-size: 13px;
}

.update-banner-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.update-btn-primary {
  background: #5dcaa5; /* your teal accent */
  color: #004751;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
}

.update-btn-dismiss {
  background: transparent;
  color: white;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  opacity: 0.7;
  font-size: 16px;
}

.update-btn-dismiss:hover {
  opacity: 1;
}
</style>
